var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-drop",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.414,9.48c0,3.538-2.876,6.413-6.414,6.413c-3.538,0-6.413-2.875-6.413-6.413c0-1.211,0.34-2.388,0.976-3.407c1.045-1.655,4.784-5.42,4.94-5.577L8,0l0.497,0.497c0.157,0.157,3.895,3.921,4.941,5.577C14.073,7.093,14.414,8.269,14.414,9.48zM13.02,9.48c0-0.95-0.262-1.865-0.768-2.667C11.503,5.62,9.055,3.067,8,1.978C6.946,3.067,4.497,5.62,3.748,6.814C3.243,7.616,2.981,8.531,2.981,9.48c0,2.771,2.248,5.019,5.019,5.019C10.771,14.499,13.02,12.251,13.02,9.48z M7.495,4.113l1.011,0.958C7.164,6.5,6.179,7.65,5.874,8.139c-0.253,0.4-0.383,0.862-0.383,1.342c0,0.68,0.27,1.324,0.767,1.804l-0.976,0.993c-0.767-0.74-1.185-1.734-1.185-2.797c0-0.741,0.209-1.464,0.593-2.083C5.177,6.622,6.658,5.01,7.495,4.113z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.890d0f3fd4ab5e16f0330e3909f30924.svg";
export { ForwardRef as ReactComponent };